import React, { Component } from 'react';
import { Form } from 'antd'

import InputCustom from '../../components/default/InputCustom'
import ButtonCustom from '../../components/default/ButtonCustom'
import AvatarCustom from '../../components/default/AvatarCustom'
import SelectCustom from '../../components/default/SelectCustom'

import { connect } from 'react-redux'
import { fetchAccount, updateAccount } from '../../actions/account'
import { fetchTitle } from '../../actions/title'

const FormItem = Form.Item

class EditProfile extends Component {

    state = {
		account: {
			id: 0
		}
	}

    componentDidMount = () =>{
        this.props.fetchAccount()
        this.props.fetchTitle()
    }

    static getDerivedStateFromProps(nextProps, prevState){
        if(Object.keys(nextProps.account).length > 0 && prevState.account.id === 0){
            const account = { ...nextProps.account }
            return { account: account }
        }
        else return null;
    }
    
    onTitleChange = (id) => {
        let account = { ...this.state.account }
        account.title_id = id
        this.setState({ account })
    }


    handleSubmit = async (e) => {
        e.preventDefault()
        const { account } = this.state
        this.props.updateAccount(account)
    }
	
	onImageChange = (files) =>{
        if(files.length > 0){
           const image = files[0].originFileObj
           let account = { ...this.state.account }
           account.image = image
           this.setState({ account: account})
        }
    }
    
    onChange = (event) =>{
        const name = event.target.name
        let account = { ...this.state.account }
        account[name] = event.target.value
        this.setState({ account: account })
	}
    
    render() {
        if(Object.keys(this.props.account).length > 0){
            const {  fullname, name, surname, image, phone, title_id } = this.state.account;
            return (
                <div className="edit-profile-page-wrap">
                    <div className="edit-profile-page-title gapb-24">แก้ไขข้อมูลผู้ใช้</div>
                    <div className="edit-profile-page">
                        <div className="edit-profile-page-sub-title gapb-32">ข้อมูลสมาชิก</div>
                        <Form onSubmit={this.handleSubmit}>
                            <div className="is-row is-sm-row" style={{ alignItems: 'flex-start' }}>
                                <div className="is-22 gapr-24 is-sm-100 sm-gapr-0 sm-gapb-24" >
                                    <AvatarCustom 
                                        name={fullname} 
                                        img={image}
                                        onChange={this.onImageChange} />
                                </div>
                                <div className="is-78 is-sm-100">
                                    <FormItem label="ชื่อ - สกุล" className={`form-label required margin-bottom16 label-color65`}>
                                        <div className="input-group is-row is-sm-row ">
                                            <div className="is-22 is-sm-100 gapr-8 sm-gapr-0 sm-gapb-14">
                                                <SelectCustom
                                                    value={title_id}
                                                    marginBottom="0"
                                                    placeholder="นาย"
                                                    size="large"
                                                    required
                                                    onChange={this.onTitleChange}
                                                    option={this.props.title.map((title) => {
                                                        return { value: title.id, label: title.title }
                                                    })} />
                                            </div>
                                            <div className="is-50 is-sm-100 gapr-8 sm-gapr-0 sm-gapb-14">
                                                <InputCustom
                                                    marginBottom="0"
                                                    placeholder="ชื่อ"
                                                    size="large"
                                                    type="text"
                                                    name="name"
                                                    value={name}
                                                    onChange={this.onChange}
                                                    required
                                                />
                                            </div>
                                            <div className="is-50 is-sm-100">
                                                <InputCustom
                                                    marginBottom="0"
                                                    placeholder="สกุล"
                                                    size="large"
                                                    type="text"
                                                    name="surname"
                                                    value={surname}
                                                    onChange={this.onChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </FormItem>
                                    <InputCustom
                                        label="โทรศัพท์"
                                        labelColor="65"
                                        placeholder="โทรศัพท์"
                                        name="phone"
                                        value={phone}
                                        onChange={this.onChange}
                                        size="large"
                                        type="text"
                                        required
                                        marginBottom="0" />
                                </div>
                            </div>
                            <div className="is-row is-sm-row-reverse gapt-32 flex-end">
                                <div className="gapr-12 sm-gapr-0 is-sm-100" style={{minWidth: 160}}>
                                    <ButtonCustom
                                        borderRadius="4"
                                        color="outline-gray"
                                        label="ยกเลิก"
                                        fontSize={16}
                                        fontWeight="large"
                                        size="extra"
                                        className="center"
                                        href="/account"
                                    />
                                </div>
                                <div className="is-sm-100 sm-gapb-12" style={{minWidth: 160}}>
                                    <ButtonCustom
                                        borderRadius="4"
                                        color="blue"
                                        label="ยืนยัน"
                                        fontSize={16}
                                        fontWeight="large"
                                        size="extra"
                                        className="center"
                                        htmlType="submit"
                                    />
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            )
        } else{
            return null
        }
    }
}

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
        account: state.account,
        title: state.title
	}
}

const mapDispatchToProps = {
    fetchAccount,
    updateAccount,
    fetchTitle
}

export default connect(mapStateToProps, mapDispatchToProps)(EditProfile)
